import { aboutData } from '@/mocks/comics';

export default function AboutSection() {
  return (
    <section id="about" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6">
            {aboutData.title}
          </h2>

          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            {aboutData.content}
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {aboutData.highlights.map((item) => (
              <div
                key={item.text}
                className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-100"
              >
                <div className="w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center">
                  <i className={`${item.icon} text-primary-600 text-lg`}></i>
                </div>
                <span className="text-xs md:text-sm text-foreground-700 text-center leading-relaxed">
                  {item.text}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}